var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.375C7.5 2.339 8.34 1.5 9.375 1.5H9.75C10.7446 1.5 11.6984 1.89509 12.4017 2.59835C13.1049 3.30161 13.5 4.25544 13.5 5.25V7.125C13.5 8.161 14.34 9 15.375 9H17.25C18.2446 9 19.1984 9.39509 19.9017 10.0983C20.6049 10.8016 21 11.7554 21 12.75V16.125C21 17.16 20.16 18 19.125 18H9.375C8.87772 18 8.4008 17.8025 8.04917 17.4508C7.69754 17.0992 7.5 16.6223 7.5 16.125V3.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25004C15.0018 3.98859 14.5475 2.769 13.721 1.81604C15.3943 2.256 16.9207 3.13252 18.1441 4.35593C19.3675 5.57934 20.244 7.10575 20.684 8.77904C19.731 7.95252 18.5115 7.49829 17.25 7.50004H15.375C15.2755 7.50004 15.1802 7.46053 15.1098 7.3902C15.0395 7.31988 15 7.2245 15 7.12504V5.25004ZM4.875 6.00004H6V16.125C6 17.0201 6.35558 17.8786 6.98851 18.5115C7.62145 19.1445 8.47989 19.5 9.375 19.5H16.5V20.625C16.5 21.66 15.66 22.5 14.625 22.5H4.875C4.37772 22.5 3.90081 22.3025 3.54917 21.9509C3.19754 21.5992 3 21.1223 3 20.625V7.87504C3 6.83904 3.84 6.00004 4.875 6.00004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.06a49a6434b154017a51cd819f99c757.svg";
export { ForwardRef as ReactComponent };